import { cart, pubsub } from '@services';
import { parseHTML } from '@utils';

class CartItems extends HTMLElement {
  #unsubscribers = [];

  static {
    cart.sections.push('fetch-line-items');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:change', 'cart:update'].map((event) =>
        pubsub.subscribe(event, ({ sections }) => this.#renderSections(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Render the sections.
   * @param {Object} sections - The sections to render.
   */
  #renderSections(sections) {
    const html = parseHTML(sections['fetch-line-items']);
    const target = html.querySelector('line-items');
    this.innerHTML = target.innerHTML;
  }
}

customElements.define('line-items', CartItems);
